"use client";

import React from "react";
import ChipGroup from "@/components/creator/ChipGroup";
import { CAMPAIGN_TYPES, COMPENSATION, AREAS } from "@/app/constants/creatorNetwork";
import type { CreatorApplication } from "@/types/creatorNetwork";

type StepProps = {
  data: CreatorApplication;
  onUpdate: (patch: Partial<CreatorApplication>) => void;
  errors: Record<string, string | null | undefined>;
};

const YES_NO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const boolToChip = (value: boolean | null) =>
  value === null ? "" : value ? "yes" : "no";

export default function StepPreferences({ data, onUpdate, errors }: StepProps) {
  return (
    <div>
      <h3 className="step-title text-white text-2xl font-bold mb-1">
        Campaign preferences
      </h3>
      <p className="text-white/60 mb-6">
        Tell us the kind of collaborations you&apos;re open to.
      </p>

      <div className="mb-6">
        <ChipGroup
          label="Campaign types"
          hint="Select all that apply"
          options={CAMPAIGN_TYPES}
          mode="multi"
          value={data.campaignTypes}
          onChange={(v) => onUpdate({ campaignTypes: v as string[] })}
          error={errors.campaignTypes}
        />
      </div>

      <div className="mb-6">
        <ChipGroup
          label="Compensation you'll accept"
          options={COMPENSATION}
          mode="single"
          value={data.compensation}
          onChange={(v) => onUpdate({ compensation: v as string })}
          error={errors.compensation}
        />
      </div>

      <div className="mb-6">
        <ChipGroup
          label="Able to attend events / shoots in person?"
          options={YES_NO}
          mode="single"
          value={boolToChip(data.attendEvents)}
          onChange={(v) =>
            onUpdate({
              attendEvents: v === "" ? null : v === "yes",
              areas: v === "yes" ? data.areas : [],
            })
          }
          error={errors.attendEvents}
        />
      </div>

      {data.attendEvents && (
        <ChipGroup
          label="Areas you can attend in"
          hint="Select all that apply"
          options={AREAS}
          mode="multi"
          value={data.areas}
          onChange={(v) => onUpdate({ areas: v as string[] })}
          otherValue={data.areasOther}
          onOtherChange={(v) => onUpdate({ areasOther: v })}
          error={errors.areas}
        />
      )}
    </div>
  );
}
